export default __webpack_public_path__ + "static/media/tank_3.aa16e0ff.png";